"use client";

/**
 * Gespeicherte Ansichten — Platzhalter.
 *
 * Der Filterkopf aus dem Agent kann Ansichten (Filter + Sortierung)
 * speichern und anheften. clubhub bekommt das mit dem Backend; bis
 * dahin zeigt der Platz nichts. Die Props entsprechen dem Agent, damit
 * `filterkopf.tsx` unveraendert bleibt.
 */
export function SavedViews(_props: {
  params?: unknown;
  shapeParams?: readonly string[];
  pinnable?: boolean;
}) {
  return null;
}
